export default __webpack_public_path__ + "static/media/aktuality-clanky-foto.05a5d7e8.jpg";